import { Checkbox } from '../../form';
import { SelectionButtonPropsModel } from './selection-button-props.model';

const SelectionButton = ({
  address,
  className,
  isDisabled,
  isSelected,
  label = '',
  logo,
  size,
  onClick,
}: SelectionButtonPropsModel) => {
  const sizeLargeWidth = size === 'large' ? 'w-96' : '';
  const sizeSmallWidth = size === 'small' ? 'w-64' : '';

  const handleClick = () => {
    if (onClick && !isDisabled) {
      onClick();
    }
  };

  return (
    <div
      className={`
        flex
        gap-2
        border
        border-grey-10
        h-18
        pl-4
        rounded-xl
        dark:bg-grey-80
        dark:border-grey-70
        ${isDisabled ? 'cursor-not-allowed' : 'shadow-md cursor-pointer'}
        ${sizeLargeWidth || sizeSmallWidth} ${className || ''}
      `}
      onClick={handleClick}
    >
      <Checkbox isCheck={isSelected} isDisabled={isDisabled} />
      <div className="flex flex-col gap-2">
        <div className={`flex items-center ${address ? 'mt-auto' : 'my-auto'}`}>
          {logo && (
            <span className="pl-4">
              <img className="w-6" src={logo} alt={`logo-category-${label}`} />
            </span>
          )}
          <span
            className={`
              ml-2
              font-medium
              ${isDisabled && 'text-grey-30'}
            `}
          >
            {label}
          </span>
        </div>
        {address && (
          <span className="text-grey-50 text-xxxs mb-auto mx-auto">
            {address}
          </span>
        )}
      </div>
    </div>
  );
};

export default SelectionButton;
